
const LoadJSON = require('../../../viscomjs/load/LoadJSON');


function ProjectPreload(progressUpdate) {
    return new Promise(resolve => {

        const __loadTTLJSON = function (id, url) {
            return () => {
                return LoadJSON(id, url)
            };
        }('ttl', './js/ttl_v1.json');

        __loadTTLJSON()
            .then(resources => {
                progressUpdate({
                    progress: 100
                });
                resolve(resources);
            })
    });
}

module.exports = ProjectPreload;





// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/load/ProjectPreload.js